import script from "./RhizomeMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RhizomeMenu.vue?vue&type=script&setup=true&lang=js"

import "./RhizomeMenu.vue?vue&type=style&index=0&id=9e0cbe0c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e0cbe0c"]])

export default __exports__